import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { IAccountCountryViews } from 'src/types'
import { NoDataMsg } from '../../no-data-msg.component'

interface ICountriesViewsTableProps {
  rows: IAccountCountryViews[] | null
}

const CountriesViewsTable = ({ rows }: ICountriesViewsTableProps) => {
  const [t] = useTranslation()
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="left">
              <strong>
                <HelperWrapper t="table-country-column" />
              </strong>
            </TableCell>
            <TableCell align="center">
              <strong>
                <HelperWrapper t="products-views-views-column" />
              </strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map((row) => (
            <TableRow key={row.country} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">
                {row.country}
              </TableCell>
              <TableCell align='center'>{row.views}</TableCell>
            </TableRow>
          ))}
          {rows?.length === 0 && (
            <TableRow>
              <TableCell sx={{ border: 0 }} colSpan={2} align="center">
                <NoDataMsg message={t('country-not-found.v')} />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export { CountriesViewsTable }
